import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthProvider.jsx'

export default function SobrePage() {
  const { session } = useAuth()
  const usuario = session?.nome || 'Usuário'

  return (
    <div className="min-h-full bg-brand-900 p-6">
      <div className="mx-auto max-w-md">
        <div className="mb-6 rounded-2xl border border-white/10 bg-brand-800/50 p-6 text-center">
          <div className="mx-auto mb-4 flex h-40 w-40 md:h-48 md:w-48 items-center justify-center rounded-2xl bg-white/10 overflow-hidden">
            <img src="/logo.png" alt="Caixa Mestre Logo" className="h-full w-full object-contain" />
          </div>
          <p className="text-lg text-white/80">Sistema de Gestão de Almoxarifado</p>
          <p className="mt-1 text-sm text-white/50">Versão 4.0.0</p>
        </div>

        <div className="mb-6 rounded-2xl border border-white/10 bg-brand-800/50 p-5">
          <h2 className="mb-4 text-lg font-semibold text-white">Informações do Sistema</h2>
          <div className="space-y-3 text-sm text-white/70">
            <div className="flex justify-between border-b border-white/10 pb-2">
              <span>Desenvolvido por:</span>
              <span className="font-medium text-white">WILLIAN COSTA FEITOZA SILVA</span>
            </div>
            <div className="flex justify-between border-b border-white/10 pb-2">
              <span>Email:</span>
              <span className="font-medium text-white">WILLIAN.COSTA7465@GMAIL.COM</span>
            </div>
            <div className="flex justify-between border-b border-white/10 pb-2">
              <span>Telefone:</span>
              <span className="font-medium text-white">(66) 99931-1927</span>
            </div>
            <div className="flex justify-between border-b border-white/10 pb-2">
              <span>Data de criação:</span>
              <span className="font-medium text-white">Abril 2026</span>
            </div>
            <div className="flex justify-between border-b border-white/10 pb-2">
              <span>Última atualização:</span>
              <span className="font-medium text-white">Maio 2026 (v4.0)</span>
            </div>
            <div className="flex justify-between pt-1">
              <span>Licença:</span>
              <span className="font-medium text-white">Proprietária</span>
            </div>
          </div>
        </div>

        <div className="mb-6 rounded-2xl border border-white/10 bg-brand-800/50 p-5">
          <h2 className="mb-4 text-lg font-semibold text-white">Funcionalidades</h2>
          <ul className="space-y-2 text-sm text-white/70">
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Controle de Estoque
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Centro de Custo por Obra
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Notas Fiscais Vinculadas
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Gestão de Entregas e Devoluções
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Módulo de Pedidos e Compras
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> 13 Tipos de Relatórios
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Módulo Financeiro
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Gestão de Usuários Multi-Perfil
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Exportação PDF e CSV
            </li>
            <li className="flex items-center gap-2">
              <span className="text-green-400">✓</span> Funciona Offline (PWA)
            </li>
          </ul>
        </div>

        <div className="mb-6 rounded-2xl border border-white/10 bg-brand-800/50 p-5">
          <Link to="/app/manual" className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600/90 px-4 py-3 text-sm font-semibold text-white hover:bg-blue-600">
            📖 Manual de Uso
          </Link>
        </div>

        <div className="rounded-2xl border border-white/10 bg-brand-800/50 p-5 text-center">
          <p className="text-sm text-white/50">
            © 2026 Caixa Mestre. Todos os direitos reservados.
          </p>
          <p className="mt-2 text-xs text-white/30">
            Sistema desenvolvido para otimização do controle patrimonial
          </p>
        </div>
      </div>
    </div>
  )
}
